<template>
  <page-header-wrapper>
    <div class="erp-list-page baidao-list-page">
      <div class="erp-search-card">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="8" :sm="24">
              <a-form-item label="关键字">
                <a-input v-model="query.keyword" allow-clear placeholder="任务编号 / 发货单号 / 收货方" @pressEnter="search" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="调度状态">
                <a-select v-model="query.dispatchStatus" allow-clear placeholder="全部">
                  <a-select-option v-for="item in statusOptions" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="10" :sm="24" class="erp-search-actions">
              <a-button type="primary" icon="search" @click="search">查询</a-button>
              <a-button icon="redo" @click="reset">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="erp-table-card">
        <div class="erp-table-toolbar">
          <div>
            <h3>待配送任务</h3>
            <p>波次拣货复核完成后自动进入待调度。勾选同一仓库的任务后派车，生成待确认的线路派车单。</p>
          </div>
          <div class="erp-toolbar-actions">
            <a-button type="primary" :disabled="!selectedRows.length" @click="openDispatch">派车</a-button>
          </div>
        </div>
        <a-table
          row-key="id"
          :columns="columns"
          :data-source="rows"
          :loading="loading"
          :pagination="pagination"
          :row-selection="rowSelection"
          bordered
          size="middle"
          :scroll="{ x: 1680 }"
          @change="onTableChange"
        >
          <template slot="taskNo" slot-scope="text, record">
            <a @click="openDetail(record)">{{ text }}</a>
          </template>
          <template slot="qty" slot-scope="text">{{ qtyText(text) }}</template>
          <template slot="operation" slot-scope="text, record">
            <a @click="openDetail(record)">查看详情</a>
          </template>
        </a-table>
      </div>
    </div>

    <a-drawer title="待配送任务详情" :visible="detailVisible" width="920" @close="detailVisible = false">
      <a-descriptions v-if="detail" bordered size="small" :column="2">
        <a-descriptions-item label="任务编号">{{ detail.taskNo }}</a-descriptions-item>
        <a-descriptions-item label="调度状态">{{ detail.dispatchStatusName }}</a-descriptions-item>
        <a-descriptions-item label="来源类型">{{ detail.sourceTypeName }}</a-descriptions-item>
        <a-descriptions-item label="发货单号">{{ detail.shipNo }}</a-descriptions-item>
        <a-descriptions-item label="上游业务单">{{ detail.upstreamNo }}</a-descriptions-item>
        <a-descriptions-item label="货主">{{ detail.ownerName }}</a-descriptions-item>
        <a-descriptions-item label="发货仓库">{{ detail.warehouseName }}</a-descriptions-item>
        <a-descriptions-item label="收货方">{{ detail.receiverName }}</a-descriptions-item>
        <a-descriptions-item label="联系人">{{ detail.contactName || '—' }}</a-descriptions-item>
        <a-descriptions-item label="联系电话">{{ detail.contactPhone || '—' }}</a-descriptions-item>
        <a-descriptions-item label="收货地址" :span="2">{{ detail.receiverAddress }}</a-descriptions-item>
        <a-descriptions-item label="要求送达">{{ detail.requiredArrival }}</a-descriptions-item>
        <a-descriptions-item label="温区">{{ detail.tempZone || '—' }}</a-descriptions-item>
        <a-descriptions-item label="件数">{{ qtyText(detail.pieceQty) }}</a-descriptions-item>
        <a-descriptions-item label="优先级">{{ detail.priorityName }}</a-descriptions-item>
      </a-descriptions>
      <h4 style="margin:16px 0 8px">配送商品明细</h4>
      <a-table row-key="id" size="small" bordered :pagination="false" :data-source="detail ? detail.items : []" :columns="itemColumns" />
      <p style="margin-top:12px;color:#667085">来源链路：销售订单 → 销售出库单 → 波次拣货复核 → 本配送任务 → 线路派车 → 签收。</p>
    </a-drawer>

    <a-drawer title="派车" :visible="dispatchVisible" width="860" @close="dispatchVisible = false">
      <p style="color:#667085">按勾选顺序生成线路点位。确认后进入线路派车单，状态为待确认。</p>
      <a-form-model layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12"><a-form-model-item label="车辆" required><a-input v-model="dispatchForm.vehicleNo" placeholder="如 苏A·D5218" /></a-form-model-item></a-col>
          <a-col :span="12"><a-form-model-item label="司机" required><a-input v-model="dispatchForm.driverName" placeholder="请输入司机" /></a-form-model-item></a-col>
          <a-col :span="12"><a-form-model-item label="配送日期" required><a-date-picker v-model="dispatchForm.routeDate" value-format="YYYY-MM-DD" style="width:100%" /></a-form-model-item></a-col>
          <a-col :span="12"><a-form-model-item label="计划发车" required>
            <a-time-picker
              :value="timeValue(dispatchForm.planDepart)"
              format="HH:mm:ss"
              placeholder="请选择时间"
              style="width:100%"
              @change="(time, text) => { dispatchForm.planDepart = text || '' }" />
          </a-form-model-item></a-col>
        </a-row>
      </a-form-model>
      <a-table row-key="id" size="small" bordered :pagination="false" :data-source="dispatchRows" :columns="dispatchColumns">
        <template slot="sort" slot-scope="text, record, index">{{ index + 1 }}</template>
        <template slot="move" slot-scope="text, record, index">
          <a :disabled="index === 0" @click="moveRow(index, -1)">上移</a>
          <a-divider type="vertical" />
          <a :disabled="index === dispatchRows.length - 1" @click="moveRow(index, 1)">下移</a>
        </template>
      </a-table>
      <div style="margin-top:16px;text-align:right">
        <a-button style="margin-right:8px" @click="dispatchVisible = false">取消</a-button>
        <a-button type="primary" :loading="saving" @click="submitDispatch">确认生成线路派车单</a-button>
      </div>
    </a-drawer>
  </page-header-wrapper>
</template>

<script>
import moment from 'moment'
import { dispatchDeliveryTask, getDeliveryTask, pageDeliveryTask } from '@/api/erp/deliveryDispatch'

function qtyText (value) {
  if (value === null || value === undefined || value === '') return '—'
  const number = Number(value)
  return Number.isNaN(number) ? value : String(number)
}

export default {
  name: 'ErpDeliveryTask',
  data () {
    return {
      loading: false,
      saving: false,
      rows: [],
      selectedRowKeys: [],
      selectedRows: [],
      detailVisible: false,
      detail: null,
      dispatchVisible: false,
      dispatchRows: [],
      dispatchForm: { vehicleNo: '', driverName: '', routeDate: moment().format('YYYY-MM-DD'), planDepart: '' },
      query: { keyword: '', dispatchStatus: undefined },
      pagination: { current: 1, pageSize: 10, total: 0, showSizeChanger: true, showTotal: total => `共 ${total} 条` },
      statusOptions: [
        { value: 'pending', label: '待调度' },
        { value: 'routed', label: '已排线' },
        { value: 'dispatched', label: '已派车' },
        { value: 'delivering', label: '配送中' },
        { value: 'signed', label: '已签收' }
      ],
      columns: [
        { title: '任务编号', dataIndex: 'taskNo', width: 180, scopedSlots: { customRender: 'taskNo' } },
        { title: '来源类型', dataIndex: 'sourceTypeName', width: 110 },
        { title: '发货单号', dataIndex: 'shipNo', width: 170 },
        { title: '上游业务单', dataIndex: 'upstreamNo', width: 160 },
        { title: '货主', dataIndex: 'ownerName', width: 110 },
        { title: '发货仓库', dataIndex: 'warehouseName', width: 140 },
        { title: '收货方', dataIndex: 'receiverName', width: 160 },
        { title: '收货地址', dataIndex: 'receiverAddress', width: 220, ellipsis: true },
        { title: '要求送达', dataIndex: 'requiredArrival', width: 120 },
        { title: '温区', dataIndex: 'tempZone', width: 90 },
        { title: '件数', dataIndex: 'pieceQty', width: 90, scopedSlots: { customRender: 'qty' } },
        { title: '重量', dataIndex: 'weightText', width: 80 },
        { title: '优先级', dataIndex: 'priorityName', width: 90 },
        { title: '调度状态', dataIndex: 'dispatchStatusName', width: 100 },
        { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right', scopedSlots: { customRender: 'operation' } }
      ],
      itemColumns: [
        { title: 'SKU', dataIndex: 'skuCode', width: 140 },
        { title: '商品名称', dataIndex: 'skuName' },
        { title: '批次', dataIndex: 'batchNo', width: 140 },
        { title: '配送数量', dataIndex: 'qty', width: 100, customRender: qtyText },
        { title: '重量', dataIndex: 'weightText', width: 80 },
        { title: '体积', dataIndex: 'volumeText', width: 80 },
        { title: '温区', dataIndex: 'tempZone', width: 80 }
      ],
      dispatchColumns: [
        { title: '顺序', width: 70, scopedSlots: { customRender: 'sort' } },
        { title: '任务', dataIndex: 'taskNo', width: 170 },
        { title: '收货方', dataIndex: 'receiverName' },
        { title: '要求送达', dataIndex: 'requiredArrival', width: 120 },
        { title: '件数', dataIndex: 'pieceQty', width: 80, customRender: qtyText },
        { title: '调整', width: 120, scopedSlots: { customRender: 'move' } }
      ]
    }
  },
  computed: {
    rowSelection () {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelect,
        getCheckboxProps: record => ({ props: { disabled: record.dispatchStatus !== 'pending' } })
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    qtyText,
    load () {
      this.loading = true
      pageDeliveryTask({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        keyword: this.query.keyword,
        dispatchStatus: this.query.dispatchStatus
      }).then(res => {
        const page = res.data || {}
        this.rows = page.records || []
        this.pagination.total = Number(page.total || 0)
      }).finally(() => { this.loading = false })
    },
    search () {
      this.pagination.current = 1
      this.load()
    },
    reset () {
      this.query = { keyword: '', dispatchStatus: undefined }
      this.search()
    },
    onTableChange (pager) {
      this.pagination.current = pager.current
      this.pagination.pageSize = pager.pageSize
      this.load()
    },
    onSelect (keys, rows) {
      this.selectedRowKeys = keys
      const map = {}
      this.selectedRows.concat(rows).forEach(row => { map[row.id] = row })
      this.selectedRows = keys.map(key => map[key]).filter(Boolean)
    },
    timeValue (value) {
      if (!/^\d{2}:\d{2}:\d{2}$/.test(value || '')) return null
      const parsed = moment(value, 'HH:mm:ss', true)
      return parsed.isValid() ? parsed : null
    },
    openDetail (record) {
      getDeliveryTask(record.id).then(res => {
        this.detail = res.data
        this.detailVisible = true
      })
    },
    openDispatch () {
      const pending = this.selectedRows.filter(row => row.dispatchStatus === 'pending')
      if (!pending.length) {
        this.$message.warning('请勾选待调度任务')
        return
      }
      const warehouseId = pending[0].warehouseId
      if (pending.some(row => row.warehouseId !== warehouseId)) {
        this.$message.warning('请选择同一发货仓库下的配送任务')
        return
      }
      this.dispatchRows = pending.slice()
      this.dispatchForm = { vehicleNo: '', driverName: '', routeDate: moment().format('YYYY-MM-DD'), planDepart: '' }
      this.dispatchVisible = true
    },
    moveRow (index, step) {
      const next = index + step
      if (next < 0 || next >= this.dispatchRows.length) return
      const rows = this.dispatchRows.slice()
      const current = rows[index]
      rows.splice(index, 1)
      rows.splice(next, 0, current)
      this.dispatchRows = rows
    },
    submitDispatch () {
      if (!this.dispatchForm.vehicleNo || !this.dispatchForm.driverName || !this.dispatchForm.routeDate || !this.dispatchForm.planDepart) {
        this.$message.warning('请填写车辆、司机、配送日期和计划发车时间')
        return
      }
      if (!/^\d{2}:\d{2}:\d{2}$/.test(this.dispatchForm.planDepart)) {
        this.$message.warning('计划发车请按时:分:秒选择')
        return
      }
      this.saving = true
      dispatchDeliveryTask({
        taskIds: this.dispatchRows.map(row => row.id),
        vehicleNo: this.dispatchForm.vehicleNo,
        driverName: this.dispatchForm.driverName,
        routeDate: this.dispatchForm.routeDate,
        planDepart: this.dispatchForm.planDepart
      }).then(() => {
        this.$message.success('线路派车单已生成，等待确认派车')
        this.dispatchVisible = false
        this.selectedRowKeys = []
        this.selectedRows = []
        this.load()
      }).finally(() => { this.saving = false })
    }
  }
}
</script>
